import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import { readStream, addPath } from './utils';
export var AISummaryService = /*#__PURE__*/function () {
  function AISummaryService(props) {
    var _this = this;
    _classCallCheck(this, AISummaryService);
    _defineProperty(this, "state", {
      content: '',
      status: 'ready'
    });
    _defineProperty(this, "subscribedStateSetter", function (state) {});
    _defineProperty(this, "fetchStream", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(summaryStyle) {
        var payload, options, path, requestUrl, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              payload = {
                recipient_agent_named_id: 'summary_agent',
                agent_input: {
                  urls: [_this.url],
                  summary_style: summaryStyle
                }
              };
              options = {
                method: 'POST',
                headers: _this.config.headers,
                body: JSON.stringify(payload)
              };
              path = 'chat/v1/invoke_agent/stream';
              requestUrl = addPath(_this.config.baseUrl, path);
              _context.next = 6;
              return fetch(requestUrl, options);
            case 6:
              response = _context.sent;
              return _context.abrupt("return", readStream(response));
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    var defaultConfig = {
      baseUrl: '/gateway/api/assist',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'x-experience-id': 'smart-link',
        //TODO: EDM-9337 - Remove the hardcoded Confluence product name and find a way to populate the product name here
        'x-product': props.product || 'confluence'
      }
    };
    this.config = {
      baseUrl: props.baseUrl || defaultConfig.baseUrl,
      headers: _objectSpread({}, props.headers || defaultConfig.headers)
    };
    this.url = props.url;
  }
  _createClass(AISummaryService, [{
    key: "summariseUrl",
    value: function () {
      var _summariseUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var summaryStyle,
          stream,
          bufferContent,
          _iteratorAbruptCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          chunk,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              summaryStyle = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 'short';
              this.state = _objectSpread(_objectSpread({}, this.state), {}, {
                status: 'loading'
              });
              this.subscribedStateSetter(this.state);
              _context2.next = 5;
              return this.fetchStream(summaryStyle);
            case 5:
              stream = _context2.sent;
              bufferContent = '';
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context2.prev = 9;
              _iterator = _asyncIterator(stream);
            case 11:
              _context2.next = 13;
              return _iterator.next();
            case 13:
              if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
                _context2.next = 19;
                break;
              }
              chunk = _step.value;
              if (chunk.type === 'ANSWER_PART') {
                bufferContent += chunk.message.content;
                this.subscribedStateSetter(_objectSpread(_objectSpread({}, this.state), {}, {
                  content: bufferContent
                }));
              }
            case 16:
              _iteratorAbruptCompletion = false;
              _context2.next = 11;
              break;
            case 19:
              _context2.next = 25;
              break;
            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](9);
              _didIteratorError = true;
              _iteratorError = _context2.t0;
            case 25:
              _context2.prev = 25;
              _context2.prev = 26;
              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context2.next = 30;
                break;
              }
              _context2.next = 30;
              return _iterator.return();
            case 30:
              _context2.prev = 30;
              if (!_didIteratorError) {
                _context2.next = 33;
                break;
              }
              throw _iteratorError;
            case 33:
              return _context2.finish(30);
            case 34:
              return _context2.finish(25);
            case 35:
              this.state = {
                status: 'done',
                content: bufferContent
              };
              this.subscribedStateSetter(this.state);
            case 37:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[9, 21, 25, 35], [26,, 30, 34]]);
      }));
      function summariseUrl() {
        return _summariseUrl.apply(this, arguments);
      }
      return summariseUrl;
    }()
  }, {
    key: "subscribe",
    value: function subscribe(stateSetter) {
      this.subscribedStateSetter = stateSetter;
    }
  }]);
  return AISummaryService;
}();